<section>
  <div class="sx-dialog__scroll-area">

    <header class="sx-dialog__content">
      <h2 class="sx-dialog__heading h3">{{('metering.group-form.title' | translate:{value:
        meteringPointsToAdd.length})}}</h2>
    </header>

    <div *ngIf="groupNameControlInvalid" class="sx-customer-form__error-wrapper sx-customer-form__error-wrapper-grey">
        <span>{{'metering.group-form.group_validation_duplicate' | translate}}</span>
    </div>

    <div class="sx-dialog-add-to-group__content-small sx-dialog-add-to-group__add-group"  [ngClass]="{'active': addingNewGroup}" id="group_add_form">
      <span [hidden]="addingNewGroup">
         <svg class="sx-dialog-add-to-group__expand-control" (click)="setFocus()" >
           <use xlink:href="#baseline-add-24px" href="#baseline-add-24px" />
         </svg>
       </span>
       <span class="sx-dialog-add-to-group__expand-control" (click)="setFocus()" [hidden]="addingNewGroup">
         {{'metering.group-form.create_new' | translate}}
       </span>
       <mat-checkbox [hidden]="!addingNewGroup" [(ngModel)]="addingNewGroup" (change)="newGroupChange(addingNewGroup)"></mat-checkbox>
       <mat-form-field class="sx-dialog-add-to-group__add-input" >
         <input matInput (click)="setFocus()" [(ngModel)]="newGroupName" class="" placeholder="{{'metering.group-form.create_new' | translate}}" #groupName id="field_group_name"/>
       </mat-form-field>
     </div>
     <div class="sx-dialog__sectioner sxl-space-between">
      <span>{{'metering.group-form.group' | translate}}</span>
      <span>{{'metering.group-form.count' | translate}}</span>
    </div>
    <div class="sx-dialog__content">
      <div class="sx-dialog__option-row" *ngFor="let meteringGroup of meteringGroupsView; let i=index" id="group_{{i}}">
        <mat-checkbox [(ngModel)]="meteringGroup.selected" (change)="selectionChange($event)" [value]="meteringGroup" id="field_group_chkbox_{{i}}">{{meteringGroup.name}}</mat-checkbox>
        <div class="sx-dialog__option-fragment-end">{{meteringGroup.meteringPoints.length}}</div>
      </div>
    </div>
  </div>
  <div class="sxh-button-footer sxl-align-right sxl-horizontal-stack-small">
    <button class="sx-button sx-button--white" mat-button (click)="onCancel()" appTrackClick sxaction="Button meteringpoint group cancel" id="group_form_cancel_btn">{{'core.button.cancel' |
      translate}}</button>
    <button class="sx-button sx-button--magenta" mat-button (click)="onSave()" appTrackClick sxaction="Button meteringpoint group add meteringpoints"  id="group_form_save_btn" [disabled]="hasNoSelection && (!addingNewGroup || newGroupName.length === 0)">{{'core.button.save_and_close' |
      translate}}</button>
  </div>
</section>
